import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

/** 24px chip with 12px type and tight label padding for dense table cells. */
export const CompactChip = styled(Chip, {
  shouldForwardProp: prop => prop !== 'emphasized',
})<{ emphasized?: boolean }>(({ theme, emphasized }) => ({
  flexShrink: 0,
  height: 24,
  fontSize: '0.75rem',
  '& .MuiChip-label': { paddingLeft: theme.spacing(1), paddingRight: theme.spacing(1) },
  ...(emphasized && { fontWeight: theme.typography.fontWeightMedium, lineHeight: 1 }),
}));
